import { Menu, Button, Dropdown } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { ClickParam } from 'antd/es/menu';
import React from 'react';
import classNames from 'classnames';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';

import { withRouter } from 'react-router';
import { getMapStateToProps } from '@/utils/utils';
import { languageLabels, LANGUAGELABLE, languageToLocal } from '@/constants/Languages';
import { connect } from 'dva';
import _ from 'lodash';

interface SelectLangProps {
  modelKey: any;
}

const SelectLang: React.FC<SelectLangProps> = (props: any) => {
  const {
    meta: {
      translations: { lang },
    },
    ca: { businessConfigs, viewerType, caModuleLoaded },
    modelKey,
    dispatch,
  } = props;

  const disableLangSwitch = viewerType === 'staff' && caModuleLoaded.api.staffLogin ? true : false;

  const renderLanguageLabel =
    modelKey === 'ca'
      ? LANGUAGELABLE.filter((x: any) => businessConfigs.displayLang.includes(x))
      : LANGUAGELABLE;

  const updateTranslations = (language: string) => {
    if (lang === language) {
      return;
    }

    dispatch({
      type: 'meta/setViewingLang',
      viewingLang: language,
    });

    if (modelKey) {
      dispatch({
        type: `${modelKey}/fetchMeta`,
        reload: 'trans',
      });
    }

    //如果是od || ca的话需要重置
    if (modelKey === 'od' || modelKey === 'ca') {
      dispatch({
        type: `${modelKey}/setLoadedModule`,
        reload: 'view-trans',
      });

      if (modelKey === 'od') {
        //如果是od变的语言 要再多做一步处理
        //把redux里面的socketItem清掉 重新建立握手
        dispatch({
          type: `util/setSocketItem`,
        });
      }
    }
  };

  const changeLang = ({ key }: ClickParam): void => updateTranslations(key);
  const langMenu = (
    <Menu className={styles.menu} selectedKeys={[lang]} onClick={changeLang}>
      {renderLanguageLabel.map(locale => (
        <Menu.Item key={locale}>{languageLabels[locale]}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={langMenu}
      placement="bottomRight"
      trigger={['click']}
      disabled={disableLangSwitch}
    >
      <Button type="link" className={styles.langButton}>
        <div>{languageLabels[lang]}</div>
        <FontAwesomeIcon icon={faLanguage} className={styles.langIcon} />
      </Button>
    </Dropdown>
  );
};

export default connect(getMapStateToProps(['meta', 'ca']))(SelectLang);
